import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-cachet',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Cachet icon</title><path d="M11.746.254C5.265.254 0 5.519 0 12c0 6.481 5.265 11.746 11.746 11.746 6.482 0 11.746-5.265 11.746-11.746 0-1.44-.26-2.82-.734-4.097l-.264-.709-1.118 1.118.1.288c.373 1.064.575 2.207.575 3.4a10.297 10.297 0 01-10.305 10.305A10.297 10.297 0 011.441 12 10.297 10.297 0 0111.746 1.695c1.817 0 3.52.47 5.002 1.293l.32.178 1.054-1.053-.553-.316A11.699 11.699 0 0011.746.254zM22.97.841l-13.92 13.92-3.722-3.721-1.031 1.03 4.752 4.753L24 1.872z" /></svg>`,
    styles: []
})
export class SimpleIconsCachetComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#7ED321';
    @Input() className: string = 'simple-icons-cachet'
    constructor() {}
    ngOnInit(): void {}
}
